import React from "react"

import { RouteComponentProps } from "react-router-dom"
import EPROPatientSignAgreement from "../../pagesEPROPatient/signAgreement"

type Params = {
  subjectCode: string;
}
const SignAgreement: React.FC<RouteComponentProps<Params>> = (props)=> {
  return (
    <EPROPatientSignAgreement
    fromDoctor
    subjectCode={props.match?.params.subjectCode}
    redirect={()=> props.history.go(-1)}/>
  )
}

export default SignAgreement
